import { TAGS_POSTFIX } from '~/constants/config';

export default ({ redirect, req }) => {
  if (!req) {
    return true;
  }
  const reqUrl = req?._parsedUrl?.pathname || req?.url || '';
  let tagName = reqUrl.split('/')[2];
  // eski emoji etiketlerin isimleri - ile bittigi icin eklendi
  if (tagName.substr(-1) === '-') {
    tagName = tagName.substring(0, tagName.length - 1);
  }
  const page = reqUrl.split('/')[4];

  if (tagName) {
    const pagination = page ? `/${page}` : '';
    redirect(301, `/${tagName}${TAGS_POSTFIX}${pagination}`);
  } else {
    return redirect(301, '/');
  }
};
